<template>
    <!-- "text", "email", "phone", "number", "url", "date", "dropdown", "json", "agent" -->
    <div
        class="contact-property-selector-inline"
        :class="{ 'contact-property-selector-inline--agent': property && property.type === 'agent' }"
        v-if="property"
    >
        <template v-if="property.type === 'dropdown'">
            <a-select v-model="cloneValue" style="width: 100%">
                <a-select-option v-for="option of property.options" :key="option" :value="option">
                    {{ option }}
                </a-select-option>
            </a-select>
        </template>
        <template v-else-if="property.type === 'agent'">
            <AgentPicker
                :single="true"
                :value="agentPickerValue"
                @input="onAgentPickerInput"
            />
        </template>
        <template v-else>
            <a-input v-model="cloneValue" style="width: 100%" />
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
import AgentPicker from "../../../../components/pickers/AgentPicker.vue";

export default {
    name: "ContactPropertySelectorInline",
    components: {
        AgentPicker,
    },
    props: {
        propertyId: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        cloneValue: null,
        property: null,
    }),
    computed: {
        ...mapState({
            properties: (state) => state.contactProperty.data,
        }),
        agentPickerValue() {
            if (!this.cloneValue) {
                return [];
            }
            return [{ type: "agent", value: this.cloneValue }];
        },
    },
    mounted() {
        this.initProperty();
    },
    methods: {
        initProperty() {
            this.property = this.properties.find((item) => item._id === this.propertyId);
            if (!this.property) {
                return;
            }
            this.cloneValue = !this.value
                ? this.property.type === "dropdown"
                    ? this.property.options[0]
                    : ""
                : this.value;
        },
        onAgentPickerInput(items) {
            var first = items && items[0];
            this.cloneValue = first && first.type === "agent" ? first.value : "";
        },
    },
    watch: {
        properties: {
            handler() {
                this.initProperty();
            },
            deep: true,
        },
        cloneValue() {
            this.$emit("input", this.cloneValue);
        },
        value() {
            this.cloneValue = this.value;
        },
    },
};
</script>

<style scoped lang="scss">
/* AgentPicker varsayılan .pr-items min-height: 300px; dar hücrelerde taşmayı önler */
.contact-property-selector-inline--agent {
    width: 100%;
    min-width: 0;

    ::v-deep .agent-picker .pr-items {
        min-height: 0;
        max-height: 200px;
    }
}
</style>
